// import { Link } from "react-router-dom";
import { Badges, P, SVG } from "../../../AbstractElements";
// import { Href } from "../../../utils/Constant";
// import { Rating } from "react-simple-star-rating";
// import { dynamicImage } from "../../../Service";
import { TableColumn } from "react-data-table-component";
import { CardRechargeTableDataColumnType, CardRechargeTableOffer } from "../../../Types/Application/Ecommerce/Ecommerce";
import Swal from "sweetalert2";
import api from "../../../utils/api";

export const allrechargeTableData = [
    {
        cardRechargeCalculationId: 17,
        ticketRFIdRef: "REF-SWP-2311",
        cardRechargeAmount: 1000
    },

];

// const ProductListTableAction = ({adultPlanId}) => {
//   return (
//     <div className="product-action">
//       <Link to={Href}>
//         <SVG iconId="edit-content" style={{ fill: 'blue' }} />
//       </Link>
//       <button className="btn btn-sm">
//       <SVG iconId="trash1" style={{ fill: 'red' }}/>
//       </button>
//       <p>{adultPlanId}</p>
//     </div>
//   );
// };

const handleDelete = async (id: number) => {
    // Your delete logic here (API call, state update, etc.)
    // console.log("Deleting ID:", id);
    try {
    //   await api.delete(`/api/TicketBooking/DeleteTicketBooking?bookingId=${id}`);
      Swal.fire('Deleted!', '  Record has been deleted.', 'success');
  
      // Optional: refresh the list
    //   setCardAssignTableDatas((prev) => prev.filter((item: { adultPlanId: any; }) => item.adultPlanId !== id));
    } catch (error) {
      Swal.fire('Error!', 'Failed to delete the record.', 'error');
      console.error("Delete error:", error);
    }
  };

interface ProductListTableActionProps {
    cardRechargeCalculationId: any;
  onDelete: (id: number) => void;
}

export const AllRechargeTableAction: React.FC<ProductListTableActionProps> = ({ cardRechargeCalculationId, onDelete }) => {

  const handleDeleteClick = () => {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this record!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes, delete it!',
    }).then((result) => {
      if (result.isConfirmed) {
        onDelete(cardRechargeCalculationId);
      }
    });
  };

  return (
    <div className="product-action d-flex gap-2">
      <button className="btn btn-sm" onClick={handleDeleteClick}>
        <SVG iconId="trash1" style={{ fill: 'red' }} />
      </button>
    </div>
  );
};

export const AllCardAssignTableProductName: React.FC<CardRechargeTableOffer> = ({ title }) => {
  return (
    <div className="product-names my-2">
      <P>{title}</P>
    </div>
  );
};

export const AllCardAssignTableStatus :React.FC<CardRechargeTableOffer> = ({ title }) => {
  return (
    <Badges color="" className={`badge-light-${title === "Active" ? "secondary" : "primary" }`}>{title}</Badges>
  );
};

export const allRechargeTableDataColumn: TableColumn<CardRechargeTableDataColumnType>[] = [
    {
      name: "Ticket Number",
      cell: (row) => <AllCardAssignTableProductName title={row.ticketRFIdRef}/>,
      sortable: true,
      grow: 2,
    },
    {
      name: "Amount",
      selector: (row) => `${row.cardRechargeAmount}`,
      sortable: true,
    },
    {
      name: "Action",
      cell: (row) => <AllRechargeTableAction cardRechargeCalculationId={row.cardRechargeCalculationId} onDelete={handleDelete} />,
    },
  ];

  export const filtersData = [
    {
      name: "Choose Ticket No.",
      options: ["SWP-4893", "SWP-2311"],
    },
    {
      name: "Status",
      options: ["Active", "Inactive"],
    },
    {
      name: "customerMobileNumber",
      options: ["8347821920"],
    },
  ];